var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2292_6830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4998C11.3807 12.4998 12.5 11.3805 12.5 9.99976C12.5 8.61904 11.3807 7.49976 10 7.49976C8.61929 7.49976 7.5 8.61904 7.5 9.99976C7.5 11.3805 8.61929 12.4998 10 12.4998Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M6.02061 13.9774C5.49771 13.4554 5.08287 12.8354 4.79983 12.1529C4.51678 11.4704 4.37109 10.7388 4.37109 9.99994C4.37109 9.26107 4.51678 8.52946 4.79983 7.84696C5.08287 7.16446 5.49771 6.54447 6.02061 6.02246",
    stroke: "#020202",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M13.9766 6.02246C14.4995 6.54447 14.9143 7.16446 15.1973 7.84696C15.4804 8.52946 15.6261 9.26107 15.6261 9.99994C15.6261 10.7388 15.4804 11.4704 15.1973 12.1529C14.9143 12.8354 14.4995 13.4554 13.9766 13.9774",
    stroke: "#020202",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M3.81201 16.1871C2.9986 15.3751 2.3533 14.4107 1.91301 13.349C1.47272 12.2873 1.24609 11.1493 1.24609 9.99993C1.24609 8.85059 1.47272 7.71252 1.91301 6.65086C2.3533 5.58919 2.9986 4.62476 3.81201 3.81274",
    stroke: "#020202",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.1797 3.81274C16.9931 4.62476 17.6384 5.58919 18.0787 6.65086C18.519 7.71252 18.7456 8.85059 18.7456 9.99993C18.7456 11.1493 18.519 12.2873 18.0787 13.349C17.6384 14.4107 16.9931 15.3751 16.1797 16.1871",
    stroke: "#020202",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2292_6830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.d0c019cb843c361ec09e33c5b1ade686.svg";
export { ForwardRef as ReactComponent };